import { App, View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout } from "@pimo/pimo-components/src/lib/layouts/drag-and-drop-layout/drag-and-drop-layout";
import { PMSmallTable } from "@pimo/pimo-components/src/lib/pm-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { TestAppState } from "../../../app";
import { theme } from "../../../theme";
import { formatDate } from "../../../utils/format-date";
import { getOverviewCardCopy } from "../get-card-copy";

export function addTeamAndDurationCards(
  view: View<TestAppState, DragAndDropLayout>,
  app: App<TestAppState>
): void {
  const { language, projectName } = getOverviewCardCopy(app);

  const teamComponent = view.addComponent({
    component: PMSmallTable,
    layoutProps: {
      componentId: "projectTeamComponent",
      title: "",
      description: "",
      labels: ["team"],
    },
  });

  teamComponent.mapLayoutProps(({ language }) => ({
    componentId: "projectTeamComponent",
    labels: ["team"],
    title: getLocalizedMessage(language, "programTeam"),
    description: getLocalizedMessage(language, "showsProgramTeam"),
  }));

  teamComponent.mapState(({ settings, language }) => {
    return {
      title: getLocalizedMessage(language, "programTeam"),
      icon: "InfoOutlined",
      items: [
        {
          label: getLocalizedMessage(language, "programOwner"),
          value: settings?.configuration?.programOwner ?? "",
          chipColor: theme.palette.secondary.main,
          chipTextColor: theme.palette.primary.main,
          cutValueAfter: 20,
        },
      ],
      fixedHeight: "134px",
    };
  });

  const durationComponent = view.addComponent({
    component: PMSmallTable,
    layoutProps: {
      componentId: "projectDurationComponent",
      title: "",
      description: "",
      labels: ["team"],
    },
  });

  durationComponent.mapLayoutProps(({ language }) => ({
    componentId: "projectDurationComponent",
    labels: ["team"],
    title: getLocalizedMessage(language, "projectDuration", {
      project: projectName,
    }),
    description: getLocalizedMessage(language || "en", "showsProjectDuration", {
      project: projectName,
    }),
  }));

  durationComponent.mapState(({ settings }) => {
    const startDate =
      settings?.configuration?.reportingCycle?.startReportingDate;
    const endDate = settings?.configuration?.reportingCycle?.endReportingDate;

    return {
      title:
        getLocalizedMessage(language, "programDuration") || "Program Duration",
      icon: "InfoOutlined",
      items: [
        {
          label: "Start",
          value: formatDate(startDate),
          chipColor: theme.palette.secondary.main,
          chipTextColor: theme.palette.primary.main,
        },
        {
          label: "End",
          value: formatDate(endDate),
          chipColor: theme.palette.secondary.light,
          chipTextColor: theme.palette.primary.main,
        },
      ],
    };
  });
}
